// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_rentalNeeds(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ChapterDefaultNotificationSetting",
              "CustomClientNeedNotificationPreference",
              "MatchesOnlyNotificationSetting"
            ]);
}

var fragmentConverter = {"__root":{"rentalNeeds_CustomClientNeedNotificationPreference_areaGroup":{"f":""},"rentalNeeds_CustomClientNeedNotificationPreference":{"f":""},"rentalNeeds":{"u":"fragment_rentalNeeds"},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_rentalNeeds: unwrap_fragment_rentalNeeds
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "MULTI_UNIT" || $$enum === "LOT" || $$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
  
}

function forSalePropertyTypeEnumV5_fromString(str) {
  return forSalePropertyTypeEnumV5_decode(str);
}

var Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userHasInactiveCustomPreference",
      "storageKey": null
    },
    "action": "THROW"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsRentalNeeds_notificationSetting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsPreferenceEditDialog_settings"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "rentalNeeds",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ChapterDefaultNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "MatchesOnlyNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "areaGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationSettingsComponents_group"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationSettingsPreferenceEditDialog_clientNeed"
            }
          ],
          "type": "CustomClientNeedNotificationPreference",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};
})());

var wrap_fragment_rentalNeeds = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_rentalNeeds = unwrap_fragment_rentalNeeds;
exports.wrap_fragment_rentalNeeds = wrap_fragment_rentalNeeds;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
